import { Order } from '../order/Order';
import { ManualShipment } from '../shipment/ManualShipment';

export class OrderOrShipmentTemplate {
  id?: number;
  name?: string;
  active: boolean = true;
  defaultOrderTemplate: boolean = false;
  defaultShipmentTemplate: boolean = false;
  templateData?: Partial<Order | ManualShipment>;

  constructor(opts?: Partial<OrderOrShipmentTemplate>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.name != null) {
      this.name = opts.name;
    }
    if (opts?.active != null) {
      this.active = opts.active;
    }
    if (opts?.defaultOrderTemplate != null) {
      this.defaultOrderTemplate = opts.defaultOrderTemplate;
    }
    if (opts?.defaultShipmentTemplate != null) {
      this.defaultShipmentTemplate = opts.defaultShipmentTemplate;
    }
    if (opts?.templateData != null) {
      if (opts.templateData.type === 'ManualShipment') {
        this.templateData = new ManualShipment(opts.templateData);
      } else if (opts.templateData.type === 'Order') {
        this.templateData = new Order(opts.templateData);
      } else {
        // This should only happen when loading templates from api
        // We don't have `type` so use `stops` which the backend doesn't have on order templates
        this.templateData = opts.templateData.stops
          ? new ManualShipment(opts.templateData as ManualShipment)
          : new Order(opts.templateData as Order);
      }
    }
  }
}
